import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  ResultsDeliveryStatus,
  TaskType,
} from '@compumark/analyst-selection-tool-client';
import { first } from 'rxjs';
import { HoldPopupComponent } from '../holdpopup/hold-popup.component';
import { TooManyResultsDialogComponent } from '../too-many-results-dialog/too-many-results-dialog.component';

@Component({
  selector: 'app-hold-cell-renderer',
  standalone: false,
  templateUrl: './hold-cell-renderer.component.html',
  styleUrls: ['./hold-cell-renderer.component.scss'],
})
export class HoldCellRendererComponent {
  private dialogRef!: MatDialogRef<HoldPopupComponent>;
  reason = '';
  taskId: any;
  params!: ICellRendererParams;
  hold = false;
  public speechBoxOpened = false;
  displayError = false;

  constructor(private dialog: MatDialog) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.updateDisplayError();
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.updateDisplayError();
    const { id, holdStatus } = this.params.data;
    this.taskId = id;
    this.reason = holdStatus?.reason || '';
    this.hold = !!holdStatus?.hold;
    return true;
  }

  private updateDisplayError(): void {
    this.displayError =
      this.params.data?.resultsDeliveryStatus ===
        ResultsDeliveryStatus.TOO_MANY_RESULTS &&
      this.params.data?.taskType === TaskType.SELECTION;
  }

  openSpeechBox(): void {
    this.dialogRef = this.dialog.open(HoldPopupComponent, {
      data: { hold: this.hold, params: this.params },
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
    });

    const instance = this.dialogRef.componentInstance;

    this.dialogRef
      .afterOpened()
      .pipe(first())
      .subscribe(() => {
        this.speechBoxOpened = true;

        instance.reason$.pipe(first()).subscribe((newReason: string) => {
          this.reason = newReason;
        });

        instance.hold$.pipe(first()).subscribe((newHold: boolean) => {
          this.hold = newHold;
        });
      });

    this.dialogRef
      .afterClosed()
      .pipe(first())
      .subscribe(() => {
        this.speechBoxOpened = false;
      });
  }
  openTooManyResultsBox(): void {
    const dialogRef = this.dialog.open(TooManyResultsDialogComponent, {
      data: { resultDeliveryId: this.params.data.resultDeliveryId },
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      width: '60rem',
    });

    dialogRef
      .afterClosed()
      .pipe(first())
      .subscribe((continued: boolean) => {
        if (continued) {
          this.displayError = false;
          // Refresh grid from server so other tabs/users see updated status
          this.params.api?.refreshServerSide({ purge: false });
        }
      });
  }
}
